@if (collection) {
  <div class="card-educational-material">
    <a [routerLink]="['/kokoelma', collection.id]" class="header">
      <div class="row g-0">
        <div class="col-sm-4 col-md-12 col-lg-5 text-center text-sm-start text-md-center text-lg-start mb-3 mb-lg-0">
          <img
            [src]="collection.thumbnail"
            class="img-fluid border"
            [alt]="'demo.educationalMaterial.cover.alt' | translate" />
        </div>
        <div class="col-sm-8 col-md-12 col-lg-7 px-sm-3">
          <h3>{{ collection.name }}</h3>
          @if (collection.description) {
            <p>{{ collection.description | truncate: [75] }}</p>
          }
          <!--description-->
          <ul class="list-unstyled authors">
            @for (author of collection.authors; track author) {
              <li>{{ author }}</li>
            }
          </ul>
          <!--authors-->
        </div>
      </div>
    </a>
    @if (collection.educationalLevels?.length > 0) {
      <app-taglist
        [elementId]="'collection-educationalLevels' + collection.id"
        [tags]="educationalLevels"
        [title]="'collections.meta.educationalLevels' | translate"
        [card]="true"
        [hiddenTagsAmount]="collection.educationalLevels.length - educationalLevels.length"
        property="value"
        searchProperty="key"
      filterType="educationalLevels"></app-taglist>
    }
    <!--educationalLevels-->
    @if (collection.keywords?.length > 0) {
      <app-taglist
        [elementId]="'collection-keywords' + collection.id"
        [tags]="keywords"
        [title]="'collections.meta.keywords' | translate"
        [card]="true"
        [hiddenTagsAmount]="collection.keywords.length - keywords.length"
        property="value"
        searchProperty="key"
      filterType="keywords"></app-taglist>
    }
    <!--keywords-->
    @if (collection.languages?.length > 0 && (languages$ | async); as languages) {
      <app-taglist
        [elementId]="'collection-languages' + collection.id"
        [tags]="languages"
        [title]="'collections.meta.languages' | translate"
        [card]="true"
        property="value"
        searchProperty="key"
      filterType="languages"></app-taglist>
    }
    <!--languages-->
  </div>
}
